<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col>
                <v-combobox autocomplete="off" :items="roles" label="Role" v-model="author.role"/>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-textarea label="Grants (JSON)" v-model="author.grants"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>


	export default {
		name: "UserAuthorizationForm",
		data() {
			return {
				author: {role: "", grants: ""}
			}
		},
		props: ["value", "service"],
		watch: {
			value(newVal) {
				this.prepare(newVal);
			},
			author:
				{
					handler: function (newVal) {
						this.$emit('input', newVal);
					},
					deep: true
				}
		},
		computed: {
			roles() {
				return this.service ? (this.service.hasOwnProperty('roles') ? this.service.roles : []) : [];
			}
		},
		mounted() {
			this.prepare(this.value);
		},
		methods: {
			prepare(author) {
				if (author.role !== this.author.role || author.grants !== this.author.grants) {
					this.author = Object.assign({}, author);
					if (this.author.grants === "") {
						this.author.grants = "{}";
                    }
				}
			}
		}
	}
</script>

<style scoped>

</style>
